export enum IntegrationIssues {
	GTMContainerMissing = 0,
	GTMContainerNeedsPublishing = 1,
	NoAccessibleGoogleAnalyticsProperty = 100,
	NoConnectedGoogleAnalyticsProperty = 101,
	ConnectedAnalyticsPropertyNotInGTM = 102,
	MissingSearchConsoleSite = 200,
	SearchConsoleSitePropertyDoesNotExist = 201,
	SearchConsoleSitePropertyNotInGTM = 202,
	SearchConsoleSiteCustomerDomainMismatch = 203,
	NoSearchConsolePropertiesExist = 204,
	NoSearchConsolePropertiesVerified = 205,
	SearchConsoleSiteHasWrongAccount = 206,
	UnresolvedGoogleAccountToken = 300
}